import React from 'react'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { renderRoutes } from 'react-router-config'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import { history } from 'helpers/history'

class App extends React.PureComponent {
  render() {
    const { store, routes } = this.props
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            {renderRoutes(routes)}
          </MuiPickersUtilsProvider>
        </ConnectedRouter>
      </Provider>
    )
  }
}

export default App
